<template>
  <section class="portfolio">
    <div class="page-header">
      <h3 class="page-title" style="color:#696969 !important;">
        <!-- <button type="button" class="btn btn-outline-success btn-sm mr-2" @click="goBack()">
          <i class="mdi mdi-keyboard-backspace"></i></button> -->
        <!-- {{ contentType.label }} -->
        All Sub Categories
      </h3>
      <!-- @click="showAddModal() -->
      <!-- <b-button @click="showAddModal()" class="btn btn-success btn-fw"><i class="fa fa-plus"></i> Add Category
      </b-button> -->
      <div class="btn-group" role="group" aria-label="Basic example">
      <b-form-input type="text" class="searchInput" @keypress="handleKeyPress" placeholder="Search sub categories"
          v-model="keyword"></b-form-input>
        <b-button @click="getResults()" class="btn btn-primary"><i class="fa fa-search"></i>
        </b-button>
        <b-button @click="clearSearchInput()" class="mr-4 btn btn-danger"><i class="fa fa-trash-o"></i>
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title" style="color:#696969 !important;">Scripts</h4> -->
            <h1 v-if="empty_data_error != ''">{{ empty_data_error }}</h1>
            <table v-else class="table table-hover table-striped table-responsive" id="audios_table22">
              <thead>
                <tr class="frown" style="color:#303030 !important">
                  <th scope="col" style="width: 1%">#</th>
                  <!-- <th scope="col" style="width: 10%">Image</th> -->
                  <th scope="col" style="width: 10%">Name</th>
                  <!-- <th scope="col" style="width: 50%">Description</th> -->
                  <!-- <th scope="col" style="width: 10%">Audio File</th> -->
                  <th scope="col" style="width: 1%">Created Date</th>
                  <th scope="col" style="width: 1%">Status</th>
                  <!-- <th scope="col" style="width: 5%">Is Paid</th> -->
                  <th scope="col" style="width: 1%">Actions</th>
                </tr>
              </thead>
              <tbody style="color:#696969 !important;">
                <tr v-for="(item, index) in items" :key="item.id">
                  <td scope="row" class="sorting_1">{{ index + 1 }}</td>
                  <!-- <td>
                    <img :src="item.image" alt="" />
                  </td> -->
                  <td>
                    <p class="bigText">
                      {{ item.title }}
                    </p>
                  </td>

                  <td>
                    <p class="bigText">
                      <!-- {{ item.created_at | moment('ll') }} -->
                      {{ getFormattedTime(item.created_at) }}
                    </p>
                  </td>

                  <!-- <td>
                    <p class="bigText">
                      {{ item.description }}
                    </p>
                  </td> -->

                  <!-- <td>
                    <a href="javascript:;" @click="play_aud(item.path)"
                      class="btn btn-outline-success btn-rounded listbox w3-bar-item w3-button believe-btn">
                      <i class="mdi mdi-play"></i>
                    </a>
                  </td> -->

                  <td>
                    <toggle-button @change="changeStatus(item)" :value="(item.status == 'Active') ? true : false" />
                  </td>
                  <!-- 
                  <td>
                    <toggle-button color="rgb(0,123,255)" @change="changeSubscriptionStatus(item)"
                      :value="(item.is_paid == 1) ? true : false" />
                  </td> -->

                  <td>

                    <button class="btn btn-info" @click="showShowModal(item.title, item.id)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-warning" @click="showEditModal(item.id, item.title)">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-danger" @click="showAlert(item.id)">
                      <i class="fa fa-trash-o"></i>
                    </button>


                    <!-- <b-dropdown class="" right variant="info">
                      <template slot="button-content">
                        Actions
                      </template>
                           
                      <a href="javascript:;" class="" style="text-decoration:none;">
                        <b-dropdown-item @click="
                        showShowModal(
                          item.id,
                        )">
                          <i class="fa fa-eye mr-2"></i>
                          Show

                        </b-dropdown-item>
                      </a>

                    
                      <a href="javascript:;" class="" style="text-decoration:none;">
                        <b-dropdown-item @click="
                        showEditModal(
                          item.id,
                          item.title,
                        )">
                          <i class="fa fa-pencil mr-2"></i>
                          Update

                        </b-dropdown-item>
                      </a>
                    
                      <a href="javascript:;" @click="showAlert(item.id)" style="text-decoration:none;">
                        <b-dropdown-item>
                          <i class="fa fa-trash-o mr-2"></i>
                          Delete
                        </b-dropdown-item>
                      </a>
                    </b-dropdown> -->

                  </td>
                </tr>
              </tbody>
            </table>

            <div v-if="!searchButtonClicked &&  empty_data_error == ''" class="row">
              <div class="col-md-6 pageInfoBox">
                Total records : {{ total_data }}
                | Total pages : {{ items_total }}
                | Current page : {{ page }}
                <!-- <input type="number" min="1" class="pageInfoInput" v-model="page" />  -->
              </div>
              <div class="col-md-6 text-right">
                <button class="btn btn-success" :disabled="pagiBackButtonDisabled" @click="getData('previous')"><i
                    class="fa fa-arrow-left" aria-hidden="true"></i></button>
                <button class="btn btn-success" :disabled="pagiNextButtonDisabled" @click="getData('next')"><i
                    class="fa fa-arrow-right" aria-hidden="true"></i></button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <vue-snotify></vue-snotify>
  </section>
</template>

<script>
import AudioCategoryEditModal from "../modals/audio-category-modals/AudioCategoryEditModal.vue";
import AudioCategoryAddModal from "../modals/audio-category-modals/AudioCategoryAddModal.vue";
import api from "../../config/api.js";
export default {
  name: "ListingContainer",
  components: {
    AudioCategoryEditModal,
    AudioCategoryAddModal,
  },

  props: {
    contentType: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      baseUrl: "", // search & pagination work
      searchedUrl: "", // search & pagination work
      searchButtonClicked: false, // search & pagination work
      keyword: "", // search & pagination work
      pagiBackButtonDisabled: true, // search & pagination work
      pagiNextButtonDisabled: false, // search & pagination work
      page: 0, // search & pagination work
      items_total: 0, // search & pagination work
      total_data: 0, // search & pagination work
      keywordEmptyAfterDelete: false, // search & pagination work
      items: [], // search & pagination work

      data_table: null,
      computed_count: 0,
      empty_data_error: "",
      items_data: "",
    }
  },

  // computed: {
  //   items: {
  //     get() {
  //       console.log('get');
  //       this.computed_count++;
  //       // console.log(this.$store.getters[`${this.contentType.name}/list`]);
  //       if (this.computed_count > 1 && this.$store.getters[`${this.contentType.name}/list`].length == 0) {
  //         this.empty_data_error = "Data Not Found!"
  //       }
  //       else {
  //         this.setTable();
  //         return this.$store.getters[`${this.contentType.name}/list`];
  //       }
  //     },
  //     set(value) {
  //       this.items_data = value;
  //     }
  //   }
  // },
  async created() {
    await this.$store.dispatch('setDataInEditForm2', [])
    localStorage.removeItem('data_for_edit2');

    this.$root.$refs.Category = this;
    // await this.$store.dispatch(`${this.contentType.name}/all`);
    if (this.$store.getters['getMessage']) {
      let obj = this.$store.getters['getMessage'];
      this.$swal('Success!', obj.msg, 'success')
      // this.showSnotifySuccess(obj.msg)
      this.$store.dispatch('setMessage', "");
    }
  },

  mounted() {
    // this.setTable();
    this.getData('next');
  },

  watch: {
    // search & pagination work
    keyword(after, before) {
      if (after != "") {
        if (this.items.length > 0) {
          this.empty_data_error = "";
        }
      } else if (after == "" && !this.keywordEmptyAfterDelete) {
        this.searchButtonClicked = false;
        this.getData();
      }
    },
    // search & pagination work
  },

  methods: {

    handleKeyPress(event) {
      if (event.key == "Enter" && this.keyword != "") {
        this.getResults()
      }
    },

    clearSearchInput() {
      this.keyword = "";
      this.keywordEmptyAfterDelete = false;
    },

    getResults() {
      if (this.keyword != "") {
        this.searchButtonClicked = true;
        api.get('/admin/livesearch-course-categories', { params: { keyword: this.keyword } })
          .then(res => {
            console.log('get results data ::: ', res.data);
            this.items = res?.data
            if (this.items.length == 0) {
              this.empty_data_error = "Data Not Found!"
            } else {
              this.empty_data_error = "";
            }
          })
          .catch(error => console.log("getResults : ", error));

        console.log(this.items);
      }
    },

    async getData($info = null) {
      this.searchButtonClicked = false;
      if (this.$store.state.pageNumberAfterAction != "") {
        console.log("store data :::: ", this.$store.state.pageNumberAfterAction);
        this.page = this.$store.state.pageNumberAfterAction;
        this.$store.state.pageNumberAfterAction = "";
      } else if ($info == "next") {
        this.page = ++this.page;
      } else if ($info == "previous") {
        this.page = --this.page;
      }

      console.log("page watch : ", this.page);
      console.log("page watch items lenght : ", this.items.length);
      console.log("page watch items lenght orignal: ", this.items_total);

      console.log("get Data page num : ", this.page);
      let result = await api.get(`/admin/all-course-cat?page=${this.page}`);
      if (result.status == 200) {
        console.log("new audios data :::: ", result.data);
        this.items = result?.data?.all_course_categories;
        this.items_total = result?.data?.total;
        this.total_data = result?.data?.total_data;
        if (this.items.length > 0) {
          this.empty_data_error = "";
          this.pagiBackButtonDisabled = (this.page > 1) ? false : true;
          this.pagiNextButtonDisabled = (this.page >= this.items_total) ? true : false;
        }
        else {
          this.empty_data_error = "Data Not Found!"
        }

      }
    },


    goBack() {
      let prev_url = "/all-course-modules";
      this.$router.push({ path: prev_url });
    },

    async changeStatus(item) {
      item.status = !item.status
      try {
        let result = await api.post(`/admin/course-cat-status?id=${item.id}`);
        this.$swal('Success!', result.data.message, 'success')
        // await this.$store.dispatch(`course-categories/all`);
        if (this.keyword != "") {
            this.getResults()
          } else {
            this.getData();
          }
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },


    // setTable() {
    //   setTimeout(() => {
    //     if (this.items.length > 0) {
    //       this.data_table = $("#audios_table").DataTable();
    //     }
    //   }, 2000);
    // },


    async showShowModal(name, id) {
      console.log('show moal open ' , this.page);
      await this.$store.dispatch('setHeaderData', 
      { "pageNumberCategory": this.page,"category_name": name })
      var obj = { "pageNumberCategory": this.page,"category_name": name };
      localStorage.setItem('data_for_header', JSON.stringify(obj));

      await this.$store.dispatch('setDataInEditForm', {
        "type": this.contentType.name, id
      })
      var obj = {
        "type": this.contentType.name, id
      };
      localStorage.setItem('data_for_edit', JSON.stringify(obj));

      // this.$refs['edit-modal'].show()
      const url = `/course/list/${id}`
      // console.log(url);
      this.$router.push({ path: url });
    },


    async showEditModal(id, title) {
      await this.$store.dispatch('setDataInEditForm', {
        "pageNumber": this.page,"type": this.contentType.name,
        id, title
      })
      var obj = {
        "pageNumber": this.page,"type": this.contentType.name, id, title
      };
      localStorage.setItem('data_for_edit', JSON.stringify(obj));
      // this.$refs['edit-modal'].show()
      const url = `/${this.contentType.name}/${id}/edit`
      // console.log(url);
      this.$router.push({ path: url });
    },

    async showAddModal() {
      await this.$store.dispatch('setDataInEditForm', { "type": this.contentType.name })
      // this.$refs['add-modal'].show()
      const url = `/${this.contentType.name}/add`
      console.log(url);
      this.$router.push({ path: url });
    },

    showSnotifySuccess(msg) {
      let obj = this.$store.getters['getMessage'];
      this.$snotify.success(obj.msg, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },
    showSnotifyError(msg) {
      let obj = this.$store.getters['getMessage'];
      this.$snotify.error(obj.msg, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });
    },

    showAlert(id) {
      try {
        let endpoint2 = "/admin/delete-course-cat/";
        const module_name = this.contentType.name;
        // if (module_name) {
        //   if (module_name == "hypnosis-categories") {
        //     endpoint2 = "/admin/delete-hypnosis-cat/";
        //   }
        //   else if (module_name == "meditation-categories") {
        //     endpoint2 = "/admin/delete-meditation-cat/";
        //   }
        //   else if (module_name == "affirmation-categories") {
        //     endpoint2 = "/admin/delete-affirmation-cat/";
        //   }
        // }
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(async (res) => {
          if (res.value) {
            let result = await api.delete(endpoint2 + id);
            if (result.status == 200) {
              // this.data_table.destroy();
              // result = await this.$store.dispatch(`${this.contentType.name}/all`);
              this.getData();
              this.$swal(
                'Deleted!',
                'Sub Category has been deleted.',
                'success'
              ).then(() => {
                this.keyword = "";
                this.keywordEmptyAfterDelete = true;
              })
            }
          }
        })
      } catch (error) {
        let err = error.response.data.message;
        this.$store.dispatch('setMessage', { err });
        this.showSnotifyError()
      }
    }
  }
};
</script>

<style>
table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  text-align: left;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}

tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #efefef;
}

td,
i th {
  padding: 0.25em;
}

.effect-text-in-footer {
  margin-bottom: 30px;
  padding-bottom: 10px;
  text-align: center;
  box-shadow: -2px 8px 20px 2px #0000002b;
}

.portfolio-grid .effect-text-in img {
  z-index: 100;
  opacity: 1;
  height: 50px;
  object-fit: cover;
}

.portfolio-grid figure {
  background: #fff !important;
}

.portfolio-grid .btn-outline-secondary:hover,
.portfolio-grid .btn-outline-secondary:focus,
.portfolio-grid .btn-outline-secondary:active {
  border-color: #3bccb0 !important;
  background: #3bccb0 !important;
  color: #ffffff;
}

.portfolio-grid .btn-outline-secondary,
.portfolio-grid .btn-outline-secondary,
.portfolio-grid .btn-outline-secondary {
  border-color: #3bccb0;
  color: #3bccb0;
}
</style>
